<div class="odx-bar-parent h-100" odxLayout="flex">
  <app-configuration-wizard-back-button #backButton [project]="project" [floorplanGroup]="FloorplanMenuType.MONITORING_UTILITY">
  </app-configuration-wizard-back-button>
  <odx-wizard #configurationWizard [vertical]="true" (activeStepChanged)="setActiveStep($event)">
    <odx-wizard-step i18n="@@utilityConfiguration.wizard.step1">Devices</odx-wizard-step>
    <odx-wizard-step i18n="@@utilityConfiguration.wizard.step2">Summary</odx-wizard-step>
  </odx-wizard>

  @if (selectedFamily$ | async; as family) {
    <app-option-selector
      class="w-100"
      [hidden]="activeStep !== 0"
      [selectedFamily]="family"
      [originalOptions]="originalConfiguration?.devices"
      [title]="UtilitySelectorTitleKeyMap[UtilitySelectorType.DEVICES]"
      [step]="family.steps[0]"
      [hasQuantities]="true"
      [category]="MonitoringCategory.UTILITY"
      [categoryLabel]="overviewCategoryLabelMap[UtilitySelectorType.DEVICES]"
      [filter1Label]="filter1LabelMap[UtilityFilterLabel.LABEL]"
      [filter1InputPlaceholder]="filter1LabelMap[UtilityFilterLabel.INPUT_PLACEHOLDER]"
      [filter2Label]="filter2LabelMap[UtilityFilterLabel.LABEL]"
      [filter2InputPlaceholder]="filter2LabelMap[UtilityFilterLabel.INPUT_PLACEHOLDER]"
      (optionsSelect$)="setSelectedDevices($event)"
      (formReady)="selectedDevicesForm = $event"
    >
    </app-option-selector>
  }

  @if (selectedFamily$ | async) {
    <app-monitoring-overview
      [hidden]="activeStep !== 1"
      [title]="UtilitySelectorTitleKeyMap[UtilitySelectorType.OVERVIEW]"
      [sections]="groupedSections"
      [showCategory]="true"
    ></app-monitoring-overview>
  }

  <app-product-config-stepper-bar
    (dismiss)="backButton.navigateBack()"
    (next)="onSubmit()"
    (previous)="onPrevious()"
    [activeStep]="activeStep"
    [steps]="steps"
  >
  </app-product-config-stepper-bar>
</div>
